import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { AUCTIONS } from '../../models/auctions';
import { VW_SERIES } from '../../models/series';
import { HeaderService } from '../../header.service';
import * as Globals from '../../globals';
declare var $: any;

@Component({
  selector: 'app-auction-detail',
  templateUrl: './auction-detail.component.html',
  styleUrls: ['./auction-detail.component.css']
})
export class AuctionDetailComponent implements OnInit {

  @Input() userProfile: any;
  loading: boolean;
  @Input() aucId: number;
  @Input() cdAucType: string;
  @Input() authMenu: any;
  @Output() goToSeries = new EventEmitter();
  @Output() refreshParent = new EventEmitter;
  @Output() goToReport = new EventEmitter();
  auction: AUCTIONS;
  series: VW_SERIES[];
  dataSeries: VW_SERIES[];
  auctype: any[];
  cds: any[];
  status: string= '';
  dCloseOpt: any;
  dSettleOpt: any;
  checked: boolean;
  checkItems: number = 0;
  constructor(
    private http: Http, vRef: ViewContainerRef,
    public toastr: ToastsManager, private headerService: HeaderService) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  ngOnInit() {
    this.dCloseOpt = { format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };
    this.dSettleOpt = { format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };
    this.newAuction();
    this.getAuctionType();
  }
  goReport(id: number, name: string, btid: number) {
    this.goToReport.emit({ id: id, name: name, btid: btid });
  }
  goSeries(id: number, name: string) {
    this.goToSeries.emit({ id: id, name: name });
  }
  newAuction() {
    this.auction = new AUCTIONS(0, null, new Date(), new Date(), new Date(), new Date(), null, null, null, null, null, this.userProfile.USER_ID);
  }
  getAuctionType() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ref/cds?cgno=18&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.auctype = res.json();
        if (this.aucId > 0) {
          this.getAuction();
        }
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getAuction() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/auctions?id=' + this.aucId + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.auction = res.json();
        this.auction.OPEN_DATE = new Date(this.auction.SOPEN_DATE);
        this.auction.CLOSE_DATE = new Date(this.auction.SCLOSE_DATE);
        this.auction.SETTLE_DATE = new Date(this.auction.SSETTLE_DATE);
        this.auction.EXTRA_DATE = new Date(this.auction.SEXTRA_DATE);
        /*this.dCloseOpt = { startDate: this.auction.OPEN_DATE, format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };*/
        this.getSeries();
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  getSeries() {
    this.loading = true;
    this.http.get(Globals.serviceUrl + 'ritel/series?auctionId=' + this.auction.AUCTION_ID + '&aucType=' + this.cdAucType + '&t=' + new Date().getTime(), { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        this.series = res.json();
        console.log(this.series);
        this.loading = false;
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }

  getCheckItems() {
    this.checked = false;
    this.checkItems = 0;
    for (var i = 0; i < this.series.length; i++) {
      if (this.series[i].CHECKED) {
        this.checkItems++;
      }
    }
  }

  setConfirm(val: any) {
    this.dataSeries = [];
    for (var i = 0; i < this.series.length; i++) {
      if (this.series[i].CHECKED) {
        this.series[i].CD_STATUS = val;
        this.dataSeries.push(this.series[i]);
      }
    }
    if (this.dataSeries.length > 0) {
      this.http.put(Globals.serviceUrl + 'ritel/confirmseries?id=' + this.userProfile.USER_ID, this.dataSeries, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.checkItems = 0;
          this.checked = false;
          this.toastr.success('Data berhasil disimpan');
          this.loading = false;
          this.getSeries();
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }

  loadParent(val: any) {
    this.refreshParent.emit({ aucId: this.auction.AUCTION_ID, aucName: this.auction.AUCTION_NAME, mode: val, cdAucType: this.auction.CD_AUCTION_TYPE });
  }

  Save() {
    this.loading = true;
    this.auction.SOPEN_DATE = Globals.formatDateTime(this.auction.OPEN_DATE);
    this.auction.SCLOSE_DATE = Globals.formatDateTime(this.auction.CLOSE_DATE);
    this.auction.SSETTLE_DATE = Globals.formatDate(this.auction.SETTLE_DATE);
    this.auction.SEXTRA_DATE = Globals.formatDateTime(this.auction.EXTRA_DATE);
    this.auction.CREATED_BY = 1;
    if (this.aucId == 0) {
      this.http.post(Globals.serviceUrl + 'ritel/auctions', this.auction, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.auction = res.json();
          this.aucId = this.auction.AUCTION_ID;
          this.loadParent(1);
          this.getAuction();
          this.toastr.success('Data berhasil disimpan');

          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
    else {
      this.http.put(Globals.serviceUrl + 'ritel/auctions?id=' + this.aucId, this.auction, { headers: this.headerService.getHeader() })
        .subscribe((res: Response) => {
          this.toastr.success('Data berhasil disimpan');
          this.loadParent(1);
          this.loading = false;
        }, err => {
          console.log(err);
          this.toastr.error(Globals.errorMessage(err));
          this.loading = false;
        });
    }
  }

  deleteAuction() {
    this.http.delete(Globals.serviceUrl + 'ritel/auctions?id=' + this.auction.AUCTION_ID, { headers: this.headerService.getHeader() })
      .subscribe((res: Response) => {
        $('#modal').modal('hide');
        this.toastr.success('Data berhasil dihapus');
        this.loadParent(0);
      }, err => {
        console.log(err);
        this.toastr.error(Globals.errorMessage(err));
        this.loading = false;
      });
  }
  dopenChanged(event: any) {
    /*this.dCloseOpt = { startDate: this.auction.OPEN_DATE, format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };*/
    if (this.auction.OPEN_DATE > this.auction.CLOSE_DATE) {
      this.auction.CLOSE_DATE = this.auction.OPEN_DATE;
    }
    this.setDSettle();
  }
  dcloseChanged(event: any) {
    this.setDSettle();
  }
  setDSettle() {
    /*this.dSettleOpt = { startDate: this.auction.CLOSE_DATE, format: 'dd-mm-yyyy', icon: 'fa fa-calendar', autoclose: true, todayBtn: 'linked', todayHighlight: true };*/
    if (this.auction.CLOSE_DATE > this.auction.SETTLE_DATE) {
      this.auction.SETTLE_DATE = this.auction.CLOSE_DATE;
    }
  }

}



// WEBPACK FOOTER //
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/app/auction/auction-detail/auction-detail.component.ts